import React from "react";
import { usePlayerCard } from "../../../hooks/usePlayerCard";
import { isButtonDisabled } from "../../../utils/isButtonCardDisabled";

const PlayerCardButton = ({
    setEventDetails,
    eventDetails,
    confirmCallback,
    player,
    initialEvent,
    isStaff,
}) => {
    const playerName = player?.playerName
        ? player.playerName
        : `${player.firstName} ${player.lastName}`;
    const handlePlayerCard = usePlayerCard(setEventDetails);

    return (
        <button
            style={{
                cursor: "pointer",
                border: "2px solid black",
                borderRadius: 5,
                height: 45,
                backgroundColor: eventDetails?.sideSelected?.teamColor,
                fontWeight: "700",
                fontSize: "16px",
                position: "relative",
            }}
            disabled={isButtonDisabled(eventDetails, player)}
            onClick={() =>
                handlePlayerCard(player, confirmCallback, initialEvent, isStaff)
            }
        >
            <span
                style={{
                    marginRight: 10,
                }}
            >
                {player?.playerNumber}
            </span>
            <span>{playerName}</span>
            {(player?.cards || []).includes("GELB") && (
                <div
                    style={{
                        backgroundColor: "#F8D200",
                        height: 10,
                        width: 10,
                        borderRadius: 2.5,
                        position: "absolute",
                        right: 2,
                        bottom: 2,
                    }}
                />
            )}
            {(player?.cards || []).includes("GELB ROT") && (
                <div
                    style={{
                        background:
                            "linear-gradient(-45deg, #FF0014 50%, #F8D200 50%)",
                        height: 10,
                        width: 10,
                        borderRadius: 2.5,
                        position: "absolute",
                        right: 2,
                        bottom: 2,
                    }}
                />
            )}
            {(player?.cards || []).includes("ROT") && (
                <div
                    style={{
                        background: "#FF0014",
                        height: 10,
                        width: 10,
                        borderRadius: 2.5,
                        position: "absolute",
                        right: 2,
                        bottom: 2,
                    }}
                />
            )}
            {(player?.cards || []).includes("GRÜN") && (
                <div
                    style={{
                        background: "#007836",
                        height: 10,
                        width: 10,
                        borderRadius: 2.5,
                        position: "absolute",
                        right: 2,
                        bottom: 2,
                    }}
                />
            )}
        </button>
    );
};

export default PlayerCardButton;
